import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { isLoginError, LoginScreen, sessionQueryOptions } from '@chariot/web-auth';

const searchSchema = z.object({
  /** Set by the auth function when a callback fails; see LoginScreen for the texts. */
  error: z.string().optional(),
  /** Where the `_app` guard sent the user from. Passed through to the auth function. */
  returnTo: z.string().optional(),
});

export const Route = createFileRoute('/login')({
  validateSearch: searchSchema,
  beforeLoad: async ({ context }) => {
    // Already signed in: there is nothing to do here.
    const session = await context.queryClient.query(sessionQueryOptions());
    // TanStack Router's redirect is thrown by design; it is a Response, not an Error.
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    if (session !== null) throw redirect({ to: '/' });
  },
  component: LoginRoute,
});

function LoginRoute() {
  const { error, returnTo } = Route.useSearch();

  return <LoginScreen error={isLoginError(error) ? error : undefined} returnTo={returnTo} />;
}
